<template>
  <div class="container">
    <HeadingOne class="-margin-md">ページを表示できません</HeadingOne>

    <section class="_mb-sm-60 _mb-md-120">
      <p class="_mb-30">
        正しく操作がされなかったため、ページを表示できません。
      </p>
      <template v-if="!isAuWallet()">
        <ListGroup class="-normal">
          <ListItem class="-normal -bold"
            >au PAY スマートローン会員さま</ListItem
          >
        </ListGroup>
        <ListGroup class="_mb-50">
          <ListItem class="-link" router-name="ce001"
            >会員さま専用サイトに再度ログインする</ListItem
          >
        </ListGroup>
      </template>
      <ListGroup class="-normal">
        <ListItem class="-normal -bold"
          >au PAY スマートローンの新規お申し込み手続き中のお客さま</ListItem
        >
      </ListGroup>
      <small>もう一度最初からお手続きをお願いします。</small>
      <ListGroup class="_mt-10">
        <ListItem class="-link" router-name="en001"
          >新規お申し込み手続きへ</ListItem
        >
      </ListGroup>
    </section>
  </div>
</template>

<script>
import { isAuWallet } from "../utils/UserAgent";
import HeadingOne from "../components/heading/HeadingOne";
import ListGroup from "../components/list/ListGroup";
import ListItem from "../components/list/ListItem";
import { setMeta } from "@/utils/Meta";

export default {
  name: "Tem029",
  components: {
    ListItem,
    ListGroup,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "ページを表示できません",
      description: "",
      keywords: "",
    });
  },
  data() {
    return {};
  },
  methods: {
    isAuWallet: function () {
      return isAuWallet();
    },
  },
};
</script>

<style scoped></style>
